import React, { useEffect } from 'react'
import ApiService from '../../../services/ApiService'
import { companyComponentsProps } from '../types'
import { InputData } from '../style'

const InsertCEPComponent: React.FC<companyComponentsProps> = ({ company, setCompany }) => {

  useEffect(() => {
    if (company?.street || (company?.city && company.city.name)) return

    const digitsOnlyCep = (company?.cep || '').replace(/\D/g, '')
    if (digitsOnlyCep.length === 8) {
      ApiService.companies.getCepInfo(digitsOnlyCep)
        .then((response: any) => {
          const data = response.data || {};
          const street = data.logradouro || data.street || '';
          const neighborhoodName = data.bairro || data.neighborhood?.name || data.neighborhood || '';
          const cityName = data.localidade || data.city?.name || data.city || '';
          const stateName = data.uf || data.state?.name || data.state || '';
          const returnedCep = data.cep || '';

          if (street || neighborhoodName || cityName || stateName) {
            if (setCompany) {
              setCompany((prev: any) => ({
                ...prev,
                street: street || '',
                neighborhood: { id: prev?.neighborhood?.id || 0, name: neighborhoodName || '' },
                city: { id: prev?.city?.id || 0, name: cityName || '' },
                state: { id: prev?.state?.id || 0, name: stateName || '' },
                cep: returnedCep || prev.cep || `${digitsOnlyCep.slice(0, 5)}-${digitsOnlyCep.slice(5)}`
              }))
            }
          } else {
            if (setCompany) {
              setCompany((prev: any) => ({
                ...prev,
                street: '',
                neighborhood: { id: 0, name: '' },
                city: { id: 0, name: '' },
                state: { id: 0, name: '' },
                cep: ''
              }))
            }
          }
        })
        .catch((error: any) => {
          console.log('Erro ao consultar CEP:', error)
        })
    }
  }, [company?.cep])

  const maskCEP = (value: any) => {
    return value
      .replace(/\D/g, '')
      .replace(/^(\d{5})(\d)/, '$1-$2')
      .slice(0, 9)
  }

  return (
    <InputData
      placeholder={'00000-000'}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        if (setCompany) {
          setCompany((prev: any) => ({ ...prev, cep: e.target.value }))
        }
      }}
      value={maskCEP(company?.cep || '')}
    />
  )
}

export default InsertCEPComponent